import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=b55e143e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55e143e')) {
      api.createRecord('b55e143e', component.options)
    } else {
      api.reload('b55e143e', component.options)
    }
    module.hot.accept("./WhatsApp.vue?vue&type=template&id=b55e143e&", function () {
      api.rerender('b55e143e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/WhatsApp.vue"
export default component.exports